import ToKhaiStatus from "./ToKhaiStatus";

export default ToKhaiStatus